import React, { useEffect, useState } from 'react';

import { Input, useTheme2 } from '@grafana/ui';
import lokiGrammar from 'app/plugins/datasource/loki/syntax';
import { RawQuery } from 'app/plugins/datasource/prometheus/querybuilder/shared/RawQuery';

import { TeamLBACRule } from '../types';

interface Props {
  isEditing: boolean;
  value: string;
  row: TeamLBACRule;
  prop: 'labelSelector';
  disabled?: boolean;
  onChange?: (value: string) => void;
  error?: string;
}

export const EditableCell = ({ isEditing, value, disabled, error, onChange }: Props) => {
  const [cellValue, setCellValue] = useState(value);
  const theme = useTheme2();

  useEffect(() => {
    if (!isEditing) {
      setCellValue(value);
    }
  }, [isEditing, value]);

  return isEditing ? (
    <Input
      value={cellValue}
      onChange={(event) => {
        setCellValue(event.currentTarget.value);
        if (onChange) {
          onChange(event.currentTarget.value);
        }
      }}
      invalid={!!error}
    />
  ) : (
    <span style={{ color: disabled ? theme.colors.text.disabled : 'unset' }}>
      <RawQuery query={`{ ${value} }`} lang={{ grammar: lokiGrammar, name: 'logql' }} />
    </span>
  );
};
